export const PET_LOSS_PARTNERS_FLAG = 'pet_loss_partners';

export const PET_LOSS_RESPONSES_FLAG = 'pet_loss_readiness_responses';
